import { type MCPServerInfo } from '../../types';

const DatadogCommunityServer: MCPServerInfo = {
  serverId: 'DATADOG_COMMUNITY',
  name: 'Datadog (Community)',
  slug: 'datadog-community',
  description: 'Datadog MCP Server',
  source: {
    sourceType: 'REPOSITORY',
    type: 'NATOMA',
    repositoryUrl: 'mcp/datadog-mcp-server:24f2c54',
    commitSha: '24f2c54',
    packageType: 'npm',
    packageName: ''
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: ['datadogApiKey', 'datadogAppKey'],
    properties: {
      datadogApiKey: {
        type: 'string',
        description: 'Datadog API key',
        sensitive: true
      },
      datadogAppKey: {
        type: 'string',
        description: 'Datadog Application key',
        sensitive: true
      },
      datadogSite: {
        type: 'string',
        description: 'Datadog site (e.g. datadoghq.eu)',
        sensitive: false,
        default: 'datadoghq.com'
      }
    }
  },
  deprecated: true
};

export default DatadogCommunityServer;
